'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class projectChangeModel extends ngDepModel
{
	files = [];
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}

	getValue(name){
		switch(name){
			case 'created':
			case 'updated':
			case 'display_date':
				if(this[name] == 0){
					return '';
				}
				return this.s('$filter')('u2date')(this[name], 'dd/MM/y HH:mm (Z)');
			case 'type':
				return this.getClassifValue(name, 'project_change_type');
			case 'purpose':
				if(this.purpose=='oth'){
					return this.purpose_other_value;
				}
				if(this.type == '1'){
					return this.getClassifValue(name, 'projectamendmenttype');

				}
				else if(this.type == '3'){
					return this.getClassifValue(name, 'projectsuspensiontype');
				}
				else if(this.type == '4'){
					return this.getClassifValue(name, 'projectterminationtype');
				}
				return '';
			case 'initiator':
				return this.getClassifValue(name, 'project_change_initiator');
			case 'status':
				return this.getClassifValue(name, 'project_change_status');
			case 'check_sheet_status':
				if(!this.check_sheet_applicable){
					return '';
				}
				return this.getClassifValue(name, 'project_change_check_sheet_status');
			case 'check_sheet_applicable':
				return this.getClassifValue(name, 'yesno');
			case 'amendment_number':
				if(this.amendment_number > 0){
					return 'A' + this.amendment_number;
				}
				return '';

		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
}
